import _ from "lodash";
import { assetsPath } from "../../utils";

const heroShotImg1 = `${assetsPath('phuket-laguna-park-2')}/images/gallery/hero-shot/1.jpg`;
const heroShotImg2 = `${assetsPath('phuket-laguna-park-2')}/images/gallery/hero-shot/2.jpg`;
const heroShotImg3 = `${assetsPath('phuket-laguna-park-2')}/images/gallery/hero-shot/3.jpg`;
const heroShotImg4 = `${assetsPath('phuket-laguna-park-2')}/images/gallery/hero-shot/4.jpg`;
const heroShotImg5 = `${assetsPath('phuket-laguna-park-2')}/images/gallery/hero-shot/Townhome5.jpg`;
const heroShotImg6 = `${assetsPath('phuket-laguna-park-2')}/images/gallery/hero-shot/Townhome6.jpg`;

const heroShot = [
  { 
    image: heroShotImg1,
    title: {
      en: "title en 1",
      cn: "title cn 1", 
      ru: "title ru 1",
    },
    subTitle: {
      en: "sub title en",
      cn: "sub title cn", 
      ru: "sub title ru",
    },
    position: 'left'
  },
  {
    image: heroShotImg2,
    title: {
      en: "title en 2",
      cn: "title cn 2", 
      ru: "title ru 2",
    },
    subTitle: {
      en: "sub title en",
      cn: "sub title cn", 
      ru: "sub title ru",
    },
    position: 'right'
  },
  {
    image: heroShotImg3,
    title: {
      en: "title en 3",
      cn: "title cn 3", 
      ru: "title ru 3",
    },
    subTitle: {
      en: "sub title en",
      cn: "sub title cn", 
      ru: "sub title ru",
    },
    position: 'left'
  },
  {
    image: heroShotImg4,
    title: {
      en: "title en 4",
      cn: "title cn 4", 
      ru: "title ru 4",
    },
    subTitle: {
      en: "sub title en",
      cn: "sub title cn", 
      ru: "sub title ru",
    },
    position: 'right'
  },
  {
    image: heroShotImg5,
    title: {
      en: "title en 5",
      cn: "title cn 5", 
      ru: "title ru 5",
    },
    subTitle: {
      en: "sub title en",
      cn: "sub title cn", 
      ru: "sub title ru",
    },
    position: 'left'
  },
  {
    image: heroShotImg6,
    title: {
      en: "title en 6",
      cn: "title cn 6", 
      ru: "title ru 6",
    },
    subTitle: {
      en: "sub title en",
      cn: "sub title cn", 
      ru: "sub title ru",
    },
    position: 'right'
  },
];

export default {
  heroShot,
};


// WEBPACK FOOTER //
// ./src/data/Home/gallery.js